export default __webpack_public_path__ + "static/media/3-cn.71129117.webp";